import React, { useState } from 'react'
import {
  Form,
  Button,
  Container,
  ButtonGroup,
  ToggleButton
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const SearchBox = () => {
  const [keyword, setKeyword] = useState('')
  const [radioValue, setRadioValue] = useState('1')

  const navigate = useNavigate()

  // const [alert, setAlert] = useState({
  //   show: false,
  //   message: '',
  //   variant: 'success'
  // })

  // function showAlert(message, variant = 'success', seconds = 2000) {
  //   setAlert({
  //     show: true,
  //     message,
  //     variant
  //   })

  //   setTimeout(() => {
  //     setAlert({
  //       show: false,
  //       message: '',
  //       variant: 'success'
  //     })
  //   }, seconds)
  // }

  const submitHandler = (e) => {
    e.preventDefault()
    if (keyword.trim()) {
      let word = keyword
      let radio = radioValue
      let wordradio = word + radio
      navigate(`/search/${wordradio}/*`)
    } else {
      setKeyword('')
      setRadioValue('1')
      navigate('/inventory')
    }
  }

  const radios = [
    { name: 'UPC', value: '1' },
    { name: 'Mfg', value: '2' },
    { name: 'Name', value: '3' }
  ]

  return (
    <Container>
      <Form className='d-flex' onSubmit={submitHandler}>
        <ButtonGroup className='p-2'>
          {radios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type='radio'
              className='btn btn-secondary btn-sm'
              name='radio'
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={(e) => setRadioValue(e.currentTarget.value)}
            >
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup>{' '}
        <Button type='submit' className='btn btn-primary btn-sm p-2'>
          Search
        </Button>
        <Form.Control
          type='text'
          name='q'
          onChange={(e) => setKeyword(e.target.value)}
          placeholder='UPC, Mfg, Name'
          className='form-control ml-sm-2 my-2 '
        />
      </Form>
    </Container>
  )
}

export default SearchBox
